import BasicRouterView from "../../../components/BasicRouterView.vue";

const adminPostos = {
  path: "post",
  redirect: { name: "salvos" },
  meta: {
    label: "Admin Postos",
    icon: "approval",
    show: true,
    tabsShow: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "postos/postos-novo",
      name: "postos-novo",
      meta: {
        label: "Postos",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../adminPostos/views/Postos.vue"),
    },
  ],
};

export default adminPostos;
